export default __webpack_public_path__ + "static/media/slim&fit.b17acfef.png";